import script from "./HomepageSidebarPinnedList.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageSidebarPinnedList.vue?vue&type=script&setup=true&lang=js"

import "./HomepageSidebarPinnedList.vue?vue&type=style&index=0&id=20eb7e74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20eb7e74"]])

export default __exports__